import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    mode: "dark",
    userId: "619259c0b643a263ac784e90"
};

export const globalSlice = createSlice({
    name: "global",
    initialState,
    reducers: {
        setMode: (state) => {
            state.mode = state.mode === 'light' ? 'dark' : 'light';
        }
    }
})

export const { setMode } = globalSlice.actions;

export default globalSlice.reducer;